import { render, staticRenderFns } from "./PropertyTurtle.vue?vue&type=template&id=48b79238&scoped=true&"
import script from "./PropertyTurtle.vue?vue&type=script&lang=js&"
export * from "./PropertyTurtle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b79238",
  null
  
)

export default component.exports